import React from "react";
import './../styles/default.css';
import NavbarTop from './default/Navbartop';
import Banner from './default/Banner';
import Footer from './default/Footer';

const PoliticasPrivacidad = () => {
    return (
        <>
            <div className="app-default app-container">
                <NavbarTop />
                <div className="main-content page-terminos-condiciones">
                    <div className="page-container">
                        <Banner src="/imagenes/terminos-y-condiciones/banner1.webp" type="imagen" overlay="gradient">
                            <h1 className="text-white">Aviso de Privacidad</h1>
                        </Banner>

                        <div className="container-section section flex-column gap-40">
                            <div className="flex-column gap-10">
                                <h3>1. Responsable de los datos personales</h3>
                                <p>Don Honesto es una plataforma operada por persona física con actividad empresarial conforme a las leyes mexicanas.</p>
                                <p>Para cualquier asunto relacionado con la protección de datos personales, puedes contactarnos en:</p>
                                <a href="mailto:contacto@donhonesto.com"><b>contacto@donhonesto.com</b></a>
                                <a href="tel:+523327874452"><b>+52 33 2787 4452</b></a>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>2. Datos personales que recopilamos </h3>
                                <p>Recopilamos los siguientes datos de los usuarios (clientes, profesionales y administradores): </p>
                                <ul>
                                    <li>Nombre completo</li>
                                    <li>Número telefónico</li>
                                    <li>Correo electrónico</li>
                                    <li>Domicilio y ubicación geográfica</li>
                                    <li>Fotografía del usuario y/o de servicios prestados</li>
                                    <li>Identificación oficial</li>
                                    <li>Chats y mensajes dentro de la plataforma</li>
                                    <li>Información de pago y facturación</li>
                                    <li>Datos técnicos como dirección IP, tipo de navegador, sistema operativo</li>
                                </ul>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>3. Finalidades del tratamiento </h3>
                                <p>Utilizamos esta información para:</p>
                                <ul>
                                    <li>Crear, verificar y administrar cuentas de usuario</li>
                                    <li>Conectar a clientes con profesionales verificados</li>
                                    <li>Coordinar y evaluar la prestación de servicios</li>
                                    <li>Procesar pagos y liberar fondos al concluir el servicio</li>
                                    <li>Supervisar la calidad del servicio y resolver conflictos</li>
                                    <li>Mejorar la experiencia del usuario</li>
                                    <li>Cumplir con obligaciones legales o fiscales</li>
                                </ul>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>4. Acceso a los mensajes y chats</h3>
                                <p>Don Honesto se reserva el derecho de acceder temporalmente a los mensajes intercambiados dentro de la plataforma, únicamente con fines de:</p>
                                <ul>
                                    <li>Evaluación de calidad y satisfacción</li>
                                    <li>Resolución de disputas</li>
                                    <li>Prevención de fraudes o conductas inapropiadas</li>
                                </ul>
                                <p>Solo los administradores y los usuarios involucrados tienen acceso a estas conversaciones.</p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>5. Transferencias de datos</h3>
                                <p>No compartimos tus datos con terceros sin tu consentimiento, salvo por cumplimiento legal o si es necesario para la operación del servicio (por ejemplo, procesadores de pago).</p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>6. Derechos ARCO</h3>
                                <p>Tienes derecho a Acceder, Rectificar, Cancelar u Oponerte al uso de tus datos. Para ejercer estos derechos, escríbenos a contacto@donhonesto.com con tu solicitud.</p>
                            </div>

                            <div className="flex-column gap-10">
                                <h3>7. Modificaciones al presente aviso</h3>
                                <p>Don Honesto podrá actualizar este aviso de privacidad en cualquier momento. Las modificaciones serán notificadas en esta misma sección y/o por correo electrónico.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default PoliticasPrivacidad;